import { animate, style, transition } from '@angular/animations';

export const moveAndFadeDownIf = [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-100%) translateZ(0)' }),
    animate('0.3s ease', style({ opacity: 1, transform: 'translateY(0px) translateZ(0)' })),
  ]),
  transition(':leave', [
    style({ opacity: 1, transform: 'translateY(0px) translateZ(0)' }),
    animate('0.3s ease', style({ opacity: 0, transform: 'translateY(-100%) translateZ(0)' })),
  ]),
];
